export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
      //menu highlight hook
      $(".menu-item").each(function(i, val) {
          var classes = $(val).attr("class").split(" ");
          for (var ix = 0; ix < classes.length; ix++) {
              if(window.location.href.split("/")[3].indexOf(classes[ix]) >= 0) {
                  $(val).addClass("current-menu-item");
              }
          }
      });
      //menu highlight hook

      $(".navbar-toggle").click(function() {
          toggleMenuMobile();
      });

      $(".menu-mobile-wrapper a").click(function () {
          toggleMenuMobile();
      });

      function animateCounters() {
          if ($('.counters').visible(true)) {
              $('.counters .wrap-hot').addClass("shown");
          }
      }

      function animateHiring() {
          if ($('.work-with-us-row').visible(true)) {
              $('.hiring-box, .work-with-us-row .image, .work-with-us, .jobs-url').addClass("shown");
          }
      }

      function animatePartner() {
          if ($('.row.lets-talk').visible(true)) {
              $('.overflow-image, .box, .border-content, .cta-line, .cta-lets-talk').addClass("shown");
          }
      }

      setTimeout(function() {
          animateCounters();
          animateHiring();
          animatePartner();
      }, 500);

      function toggleMenuMobile() {
          var delay = 200;
          $(".navbar-toggle").toggleClass("active");
          var menu = $(".menu-mobile-wrapper");
          var lang_selector_menu = $(".lang-selector.mobile");
          menu.removeClass("d-none");
          if($(".navbar-toggle").hasClass("active")) {
              $(".menu-mobile-wrapper li").addClass("d-none");
              $(".menu-mobile-wrapper .social .social-icon").addClass("d-none");
              menu.toggleClass("rotateInDownRight rotateOutUpRight");
              $(".menu-mobile-wrapper li").each(function(i, val) {
                  var inter = setInterval(function () {
                      clearInterval(inter);
                      $(val).removeClass("d-none fadeOutUp").addClass("animated fadeInUp");
                  }, delay * i);
              });
              $(".menu-mobile-wrapper .social .social-icon").each(function(i, val) {
                  var inter = setInterval(function () {
                      clearInterval(inter);
                      $(val).removeClass("d-none fadeOut").addClass("animated fadeIn");
                  }, delay * i);
              });
              setTimeout(function() {
                  lang_selector_menu.parent().removeClass("d-none");
              }, 500);
          } else {
              $(".menu-mobile-wrapper .social .social-icon").each(function(i, val) {
                  var inter = setInterval(function () {
                      clearInterval(inter);
                      $(val).removeClass("fadeIn").addClass("animated fadeOut");
                  }, (delay - 100) * i);
              });
              $(".menu-mobile-wrapper li").each(function(i, val) {
                  var inter = setInterval(function () {
                      clearInterval(inter);
                      $(val).removeClass("fadeInUp").addClass("animated fadeOutUp");
                  }, delay * i);
              });
              setTimeout(function() {
                  menu.toggleClass("rotateInDownRight rotateOutUpRight");
                  lang_selector_menu.parent().addClass("d-none");
              }, 1000);
          }
      }


      $(".rtu").click(function(e) {
          e.preventDefault();
          $("html, body").animate({
              scrollTop: 0,
          }, 500, 'swing');
      });

      $(window).scroll(function() {
          $(".btn-animated").each(function(i, val) {
              if($(val).visible()) {
                  $(val).addClass("show");
              }
          });
          animateCounters();
          animateHiring();
          animatePartner();
      });


      $('.sticky-posts-row').slick({
          dots: false,
          speed: 500,
          infinite: true,
          slidesToShow: 1,
          draggable: true,
          swipe: true,
          touchMove: true,
          swipeToSlide: true,
          touchThreshold: 6,
          mobileFirst: true,
          responsive: [
              {
                  breakpoint: 576,
                  settings: {
                      slidesToShow: 2,
                      infinite: true,
                      swipe: true,
                      touchMove: true,
                      swipeToSlide: true,
                      touchThreshold: 6,
                  },
              },
              {
                  breakpoint: 992,
                  settings: {
                      slidesToShow: 4,
                      infinite: true,
                      swipe: true,
                      touchMove: true,
                      swipeToSlide: true,
                      touchThreshold: 6,
                  },
              },
          ],
      });

      $('.authors-sticky').slick({
          dots: false,
          speed: 500,
          mobileFirst: true,
          slidesToShow: 2,
          infinite: true,
          swipe: true,
          touchMove: true,
          swipeToSlide: true,
          arrows: false,
          prevArrow: '<button type="button" class="slick-prev-custom"></button>',
          nextArrow: '<button type="button" class="slick-next-custom"></button>',
          responsive: [
              {
                  breakpoint: 700,
                  settings: {
                      slidesToShow: 4,
                      infinite: true,
                      swipe: true,
                      touchMove: true,
                      swipeToSlide: true,
                      arrows: true,
                  },
              },
              {
                  breakpoint: 991,
                  settings: {
                      slidesToShow: 5,
                      infinite: true,
                      swipe: true,
                      touchMove: true,
                      swipeToSlide: true,
                      arrows: true,
                  },
              },

              {
                  breakpoint: 1440,
                  settings: {
                      slidesToShow: 7,
                      infinite: true,
                      swipe: true,
                      touchMove: true,
                      swipeToSlide: true,
                      arrows: true,
                  },
              },
          ],
      });


      /* Newsletter Alerts */
      // var wpcf7Elm = document.querySelector( '.newsletter-privacy .wpcf7' );
      // if (wpcf7Elm != null) {
      //     wpcf7Elm.addEventListener('wpcf7mailsent', function() {
      //         $(".newsletter-modal.modal-success").modal();
      //     }, false);
      //     wpcf7Elm.addEventListener('wpcf7mailfailed', function() {
      //         $(".newsletter-modal.modal-fail").modal();
      //     }, false);
      // }

      $(".newsletter-privacy form input[type='text']").closest("div").append("<input type='submit' value='' class='fake-submit' />");
      if($(".validation_error").length > 0) {
          $('html, body').animate({scrollTop: $('.validation_error').closest("div[id^='gform_wrapper_']").offset().top - 200 }, 300);
      }

      if($("div[id='gform_confirmation_message_1']").length > 0 || $("div[id='gform_confirmation_message_4']").length > 0 ) {
          $(".newsletter-modal.modal-success").modal();
      }

      $(".newsletter-modal.modal-success").on('hide.bs.modal', function(){
          window.location.href = window.location.href;
      });

      /* Bootstrap 4 Slider Swipe */
      swipe_carousel("#comments-carousel.carousel", 'visibility-priority');
      swipe_carousel(".carousel:not(#comments-carousel)");

      function swipe_carousel(carousel_selector, transition_temp_class) {
          if (!$(carousel_selector).hasClass("no-swipe")) {
              $(carousel_selector).on("touchstart", function(event){
                  var offsetMove = 5;
                  var xClick = event.originalEvent.touches[0].pageX;
                  $(this).one("touchmove", function(event){
                      var xMove = event.originalEvent.touches[0].pageX;
                      if( Math.floor(xClick - xMove) > offsetMove ){
                          $(this).carousel('next');
                      }
                      else if( Math.floor(xClick - xMove) < -offsetMove ){
                          $(this).carousel('prev');
                      }
                  });
                  $(".carousel").on("touchend", function(){
                      $(this).off("touchmove");
                  });
              });
              if (typeof transition_temp_class !== "undefined") {
                  $(carousel_selector).on('slide.bs.carousel', function () {
                      $(".comment-line").addClass(transition_temp_class);
                  });
                  $(carousel_selector).on('slid.bs.carousel', function () {
                      $(".comment-line").removeClass(transition_temp_class);
                  });
              }
          }
      }

      /* Video Component */
      $(".play-icon").on("click", function () {
          var $iframe = $(this).closest(".pre-video-layer").find("iframe");
          $iframe.attr("src", $iframe.data("src")).fadeIn();
          $(this).closest(".pre-video-layer").find(".play-content").remove();
      });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js